import { useGetCurrentBoard } from 'entities/board/api/hooks/useGetCurrentBoard';
import { useFeature } from 'entities/features/hooks/use-feature';
import { useGetCurrentOrganisation } from 'entities/organisation/api/hooks/useGetCurrentOrganisation';
import { getHasHateoasAccess } from 'helpers';

/**
 * Hook to check if the user has access to a specific capability
 */
export const useUserCapability = () => {
  const { board } = useGetCurrentBoard();
  const { data: organization } = useGetCurrentOrganisation();

  const features = useFeature();

  return {
    /**
     * Capabilities from feature endpoint
     */
    availableIdentityProviders: features.identityConfirmationPwpw,

    /**
     * Capabilities for the current organization
     */

    /**
     * Check if the user has access to view own organization details
     */
    self: getHasHateoasAccess('self', organization?.__links),

    update: getHasHateoasAccess('update', organization?.__links),

    delete: getHasHateoasAccess('delete', organization?.__links),

    dataTypes: getHasHateoasAccess('dataTypes', organization?.__links),

    dataStreams: getHasHateoasAccess('dataStreams', organization?.__links),

    users: getHasHateoasAccess('users', organization?.__links),

    administrators: getHasHateoasAccess(
      'administrators',
      organization?.__links,
    ),

    boards: getHasHateoasAccess('boards', organization?.__links),

    emailCustomization: getHasHateoasAccess(
      'emailCustomization',
      organization?.__links,
    ),

    documentBranding: getHasHateoasAccess(
      'documentBranding',
      organization?.__links,
    ),

    webhooks: getHasHateoasAccess('webhooks', organization?.__links),

    templateCreatorV2: getHasHateoasAccess(
      'templateCreatorV2',
      organization?.__links,
    ),

    contactsV2: getHasHateoasAccess('contactsV2', organization?.__links),

    documentsV2: getHasHateoasAccess('documentsV2', organization?.__links),

    signingPortal: getHasHateoasAccess('signingPortal', organization?.__links),

    /**
     * Check if the user has access to data sources
     */
    dataSources: getHasHateoasAccess('dataSources', organization?.__links),

    addressVariable: getHasHateoasAccess(
      'addressVariable',
      organization?.__links,
    ),

    /**
     * Check if the user has access to technical users
     */
    technicalUsers: getHasHateoasAccess(
      'technicalUsers',
      organization?.__links,
    ),

    /**
     * Check if the user has access to transactions
     */
    transactions: getHasHateoasAccess('transactions', organization?.__links),

    /**
     * Check if the user has access to auto reminders
     */
    autoReminders: getHasHateoasAccess('autoReminders', organization?.__links),

    /**
     * PoC: Check id the user has access to create package from PDFs
     */
    pdfPackage: getHasHateoasAccess('pdfPackage', organization?.__links),

    /**
     * Capabilities for the current board
     */

    /**
     * Check if the user has access to create a document
     */
    createDocument: getHasHateoasAccess('createDocument', board?.__links),

    /**
     * Check if the user has access to create a template
     */
    createTemplate: getHasHateoasAccess('createTemplate', board?.__links),

    /**
     * Check if the user has access to companies/contractors/contacts
     */
    manageCompanies: getHasHateoasAccess('companies', board?.__links),
  };
};
